import Currency from "../../frontend/scripts/money-format";

let addtocartBtnsEle = document.querySelectorAll(".pdp-addtocart");
let notifyMeEle = document.querySelectorAll(".pdp-notify");
let pdpErrorMessEle = document.querySelectorAll(".pdp-error-message");
let selectSizeBtnEle = document.querySelectorAll(".pdp-sizeSelector-btn");

// check default variant
if (!window.productData?.hasOnlyDefaultVariant) {
  let swatchCtaEls = document.querySelectorAll(".pdp-swatch");
  let pdpAddtocartEle = document.querySelectorAll(".pdp-addtocart");

  // swatch action
  swatchCtaEls.forEach((swatch) => {
    swatch.addEventListener("click", (ele) => {
      let selectedOptionEle = ele.target.closest(".pdp-swatch");
      let selectedOption = ele.target.closest(".pdp-swatch").dataset.value;
      let productVariants = window.productData?.product.variants;

      // find selected Variant
      let selectedVariant = productVariants.find(
        (variant) => variant.option1 == selectedOption
      );
      window.productData.selectedVaraint = selectedVariant;

      // variant change event firing
      let varaintChangeEvent = new CustomEvent("variant-change");
      window.dispatchEvent(varaintChangeEvent);

      // Update active swatch
      swatchCtaEls.forEach((swatch) => swatch.classList.remove("active"));
      selectedOptionEle.classList.add("active");

      // update wishlist button
      let productWishlistBtn = document.querySelector(
        "product-info wishlist-btn"
      );
      productWishlistBtn.dataset.variantId = selectedVariant.id;
      // Update Price (Sale and Compare)
      let salePrice = selectedVariant.price;
      let comparePrice = selectedVariant.compare_at_price;
      updatePrice(salePrice, comparePrice);

      // Update variant id at ATC CTAs
      pdpAddtocartEle.forEach((btn) => {
        btn.dataset.variantid = selectedVariant.id;
      });

      //update ATC button when size selected
      showAtcBtn(true);
      showSizeBtn(false);
      pdpAtcLoading(false);

      // check variant OOS and price 0
      let currentVariantPrice = selectedVariant.price;
      if (currentVariantPrice <= 0) {
        showAtcBtn(false);
        showNotifyMeBtn(false);
      } else {
        if (!selectedVariant.available) {
          showAtcBtn(false);
          showNotifyMeBtn(true);
        } else {
          showAtcBtn(true);
          showNotifyMeBtn(false);
        }
      }

      // check popup size swatch clicked and clicked swatch variant available
      if (selectedOptionEle.classList.contains("popup-size-swatch")) {
        if (selectedVariant.available) {
          swatchAddtocart(selectedVariant);
        } else {
          let alertContEl = document.querySelector("#notify_me_alert");
          alertContEl.classList.add("active");
        }
      }
    });
  });

  // single variant default selection variants
  if (window.productData?.product.variants.length == 1) {
    swatchCtaEls[0].click();
  }

  /**
   * swatch click add to cart event desktop & mobile
   * @param {number} variant - product variant Id for add to cart
   */
  async function swatchAddtocart(variant) {
    let variantID = variant.id || null;
    let quantity = document.getElementById("pdp_quantity").value;
    let colorProp = document.getElementById("pdp_colorVar")?.value;
    let updatedQuantity = await checkVariantInCart(variantID, quantity);

    //popup close
    sizePopupVisiblity(false);

    // amimation
    if (window.matchMedia("(min-width: 768px)").matches) {
      let desktopSizeBarEl = document.querySelector(".desktop-size-swatch");
      desktopSizeBarEl.classList.remove("active");
    }
    pdpAtcLoading(true);

    // addtocart process & popup
    let alertContEl = document.querySelector("#pdp_alert_cont");

    if (variantID) {
      if (updatedQuantity > 0) {
        let itemAdded = await addItem(variantID, updatedQuantity,colorProp);
        POPUPS.Cart.updateMiniCart(true);
        if (itemAdded.status == 200) {
          setTimeout(() => {
            if (window.matchMedia("(max-width: 767px)").matches) {
              alertContEl.classList.add("active");
            }
            pdpAtcLoading(false);
            updateAlert(variantID);
            resetButtonEvent();
          }, 1000);
        } else {
          let message = `Item not added to cart.`;
          updateMessage(message, false);
          resetButtonEvent();
        }
      } else {
        const MAXPERVARIANTLIMIT = window.productData.productAtcLimit;
        let message = `${MAXPERVARIANTLIMIT} item already exist in cart`;
        updateMessage(message, false);
        resetButtonEvent();
        pdpAtcLoading(false);
      }
    } else {
      let message = `Select a size`;
      updateMessage(message, false);
      resetButtonEvent();
    }

    // reset buttons event
    function resetButtonEvent() {
      if (window.matchMedia("(min-width: 768px)").matches) {
        showAtcBtn(false);
        showSizeBtn(true);
      } else {
        showAtcBtn(false);
        showSizeBtn(true);
      }
    }
  }

  /**
   * Update Price
   * @param {number} sale - Product sale price
   * @param {number} compare - Product compare price
   */
  function updatePrice(sale, compare) {
    let salePriceEles = document.querySelectorAll(".pdp-price");
    let comparePriceEles = document.querySelectorAll(".pdp-compare-price");

    // Update Actual Price
    if (sale) {
      salePriceEles.forEach((ele) => {
        ele.innerHTML = Currency.formatMoney(sale);
        ele.classList.remove("hidden");
      });
    } else {
      if (sale <= 0) {
        salePriceEles.forEach((ele) => {
          ele.innerHTML = "Free Product";
          ele.classList.remove("hidden");
        });
      } else {
        salePriceEles.forEach((ele) => {
          ele.innerHTML = "";
          ele.classList.add("hidden");
        });
      }
    }

    // Logic to hide compare price when compare price is less and equal to sale price
    let comparePriceShow = true;
    if (compare && compare <= sale) {
      comparePriceShow = false;
    }

    // Update compare price
    if (compare) {
      comparePriceEles.forEach((ele) => {
        ele.innerHTML = Currency.formatMoney(compare);
        if (comparePriceShow) {
          ele.classList.remove("hidden");
        } else {
          ele.classList.add("hidden");
        }
      });
    } else {
      comparePriceEles.forEach((ele) => {
        ele.innerHTML = "";
        ele.classList.add("hidden");
      });
    }
  }

  /**
   * Mobile size selector popup close event
   */
  function closeSizePopup() {
    let closeSizeEle = document.querySelector(".close-size-popup");
    let closeOverlayEle = document.querySelector(".pdp-sizePupup-overlay");

    // close popup on close icon and overlay
    [closeSizeEle, closeOverlayEle].forEach((ele) =>
      ele.addEventListener("click", () => sizePopupVisiblity(false))
    );
  }
  closeSizePopup();
  /**
   * Control Visilility of alert popup mobile
   * @param {boolean} status - whether show(true) or hide(false)
   */
  function sizePopupVisiblity(status) {
    let alertContEl = document.querySelector("#pdp_size_popup");
    if (status) {
      alertContEl.classList.add("active");
    } else {
      alertContEl.classList.remove("active");
    }
  }

  // Size select button click event Desktop & mobile
  selectSizeBtnEle.forEach((ele) =>
    ele.addEventListener("click", (e) => {
      if (window.matchMedia("(min-width: 768px)").matches) {
        let desktopSizeBarEl = document.querySelector(".desktop-size-swatch");
        if (e.target.classList.contains("sticky-bar")) {
          desktopSizeBarEl.classList.add("active");
        }
      } else {
        let alertContEl = document.querySelector("#pdp_size_popup");
        alertContEl.classList.add("active");
      }
    })
  );
}

// Add to cart Trigger
addtocartBtnsEle.forEach((btn) => {
  btn.addEventListener("click", async (e) => {
    pdpAtcClicked(true);
    let variantID = btn.dataset.variantid || null;
    let quantity = document.getElementById("pdp_quantity").value;
    let colorProp = document.getElementById("pdp_colorVar")?.value;
    let updatedQuantity = await checkVariantInCart(variantID, quantity);
    let alertContEl = document.querySelector("#pdp_alert_cont");

    if (variantID) {
      if (updatedQuantity > 0) {
        let itemAdded = await addItem(variantID, updatedQuantity,colorProp);
        if (itemAdded.status == 200) {
          pdpAtcClicked(false);
          pdpAtcLoading(true);
          setTimeout(() => {
            updateAlert(variantID);
            if (window.matchMedia("(max-width: 767px)")) {
              alertContEl.classList.add("active");
            }
            pdpAtcLoading(false);
            POPUPS.Cart.updateMiniCart(true);
          }, 1500);
        } else {
          let message = `Item not added to cart.`;
          updateMessage(message, false);
          pdpAtcClicked(false);
        }
      } else {
        const MAXPERVARIANTLIMIT = window.productData.productAtcLimit;
        let message = `${MAXPERVARIANTLIMIT} item already exist in cart`;
        updateMessage(message, false);

        setTimeout(() => {
          pdpAtcClicked(false);
        }, 800);
      }
    } else {
      let message = `Select a size`;
      updateMessage(message, false);
    }
    //pdpAtcLoading(false);
  });
});

/**
 * Add to cart trigger
 * @param {number} variantId - Product selected variant ID
 * @param {number} quantity - Variant quantity to be added to cart
 * @returns
 */
async function addItem(variantId, quantity,colorProp) {
  let formData = {
    items: [
      {
        id: variantId,
        quantity: quantity,
        properties:{}
      },
    ],
  };
  // adding color line property to read on checkout
    colorProp ? formData.items[0].properties.color = colorProp : "";
  //
  const result = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  return result;
}

/**
 * Check if cart have less then 6 quantity for variant id and adjust the quantity
 * @param {number} variant - Variant ID
 * @param {number} qty - user selected quantity
 * @returns {number} - adjusted/ cart checked quantity
 */
async function checkVariantInCart(variant, qty) {
  return await fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      let cartItems = data.items;
      const checkVariant = cartItems.filter(checkVariantAvailable);
      function checkVariantAvailable(item) {
        return item.variant_id == variant;
      }
      const MAXPERVARIANT = window.productData.productAtcLimit;
      let variantQty = 0;
      if (checkVariant.length != 0) {
        variantQty = checkVariant[0].quantity;
      }
      const availableVariantQty = MAXPERVARIANT - variantQty;
      let currentQty = 0;
      if (qty >= availableVariantQty) {
        currentQty = availableVariantQty;
      } else {
        currentQty = qty;
      }
      return currentQty;
    })
    .catch((error) => {
      //console.log(error)
    });
}

/**
 * control visibility of add to cart buttons
 * @param {boolean} action - show or hide add to cart buttons
 */
function showAtcBtn(action) {
  addtocartBtnsEle.forEach((btn) => {
    if (action) {
      btn.classList.remove("hidden");
    } else {
      btn.classList.add("hidden");
    }
  });
}

/**
 * Control Visibility of Select size buttons
 * @param {boolean} action - show or hide "Select a size" buttons
 */
function showSizeBtn(action) {
  selectSizeBtnEle.forEach((btn) => {
    if (action) {
      btn.classList.remove("hidden");
    } else {
      btn.classList.add("hidden");
    }
  });
}

/**
 * Control Visibility of Notify me buttons
 * @param {boolean} action - show or hide Notify me buttons
 */
function showNotifyMeBtn(action) {
  notifyMeEle.forEach((btn) => {
    if (action) {
      btn.classList.remove("hidden");
    } else {
      btn.classList.add("hidden");
    }
  });
}

/**
 *
 * @param {string} message - Massage that need to display
 * @param {boolean} status - Message is success(true) or error(false)
 */
function updateMessage(message, status) {
  pdpErrorMessEle.forEach((ele) => {
    //reset message for status
    ele.classList.remove("success");
    ele.classList.remove("error");

    ele.innerHTML = message;
    if (status) {
      ele.classList.add("success");
    } else {
      ele.classList.add("error");
    }
  });
  messageVisiblity(true);
  setTimeout(() => {
    messageVisiblity(false);
  }, 5000);
}

/**
 *
 * @param {boolean} status - control message status show(True) and hide(false)
 */
function messageVisiblity(status) {
  pdpErrorMessEle.forEach((ele) => {
    if (status) {
      ele.classList.remove("hidden");
    } else {
      ele.classList.add("hidden");
    }
  });
}

function pdpAtcClicked(action) {
  if (action) {
    addtocartBtnsEle.forEach((ele) => ele.classList.add("clicked"));
  } else {
    addtocartBtnsEle.forEach((ele) => ele.classList.remove("clicked"));
  }
}

/**
 * PDP loading animation
 * @param {boolean} action - Action to display or hide pdp loading animation while add to cart is in process
 */
function pdpAtcLoading(action) {
  let loaderEle = document.querySelectorAll(".atc-loader");
  let cartIconEle = document.querySelectorAll(".pdp-icon-cart");
  if (action) {
    addtocartBtnsEle.forEach((ele) => ele.classList.add("loading"));
  } else {
    addtocartBtnsEle.forEach((ele) => ele.classList.remove("loading"));
  }
}

// check slicky bar positioning & control visibility events
if (window.matchMedia("(min-width: 768px)").matches) {
  let pdpStickyBarEle = document.querySelector(".pdp-sticky-bar");
  var lastScrollTop = 0;
  document.addEventListener("scroll", function (e) {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop) {
      checkStickyBar("desktop");
    } else if (scrollTop < lastScrollTop) {
      pdpStickyBarEle.classList.remove("active");
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
  checkStickyBar("desktop");
} else {
  document.addEventListener("scroll", () => {
    checkStickyBar("mobile");
  });
  checkStickyBar("mobile");
}

/**
 * Control fixed bar visibility
 * @param {string} device - Sticky bar action for "desktop" or "mobile"
 */
function checkStickyBar(device) {
  let pdpStickyBarEle = document.querySelector(".pdp-sticky-bar");
  let productTemplateEle = document.querySelector("product-template");
  let productAtcWrapper = document.querySelector(".pdp-atc-btn-wrapper");
  if (device == "mobile") {
    if (isDivAtScreenBottom(productTemplateEle)) {
      pdpStickyBarEle.classList.remove("active");
    } else {
      pdpStickyBarEle.classList.add("active");
    }
  } else if (device == "desktop") {
    if (!isDivAtScreenBottom(productTemplateEle)) {
      if (isInViewport(productAtcWrapper)) {
        pdpStickyBarEle.classList.remove("active");
      } else {
        pdpStickyBarEle.classList.add("active");
      }
    } else {
      pdpStickyBarEle.classList.remove("active");
    }
  }
}

/** Check element position on screen */
function isDivAtScreenBottom(element) {
  const rect = element.getBoundingClientRect();
  return rect.bottom <= window.innerHeight;
}

/** Check element position on screen */
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Tab open and close event
 * @param {object} evt - clicked element
 * @param {string} cityName - class and data-action name of tab content and button
 */

function openDesc(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("pdp-tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    tabcontent[i].style.opacity = "0";
  }
  tablinks = document.getElementsByClassName("pdp-tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  setTimeout(() => {
    document.getElementById(cityName).style.opacity = "1";
  }, 0);
  evt.currentTarget.className += " active";
}

let pdpTabBtnEle = document.querySelectorAll(".pdp-tablinks");
pdpTabBtnEle.forEach((ele) => {
  ele.addEventListener("click", (e) => {
    let dataAction = e.target.dataset.action;
    openDesc(e, dataAction);
  });
});

if (pdpTabBtnEle.length > 1) {
  document.getElementById("pdp_Desc_Open").click();
} else if (pdpTabBtnEle.length == 1) {
  pdpTabBtnEle[0].click();
}

/**
 * Update mobile popup content size and price when product add to cart
 * @param {number} id - variant id added to cart
 */
function updateAlert(id) {
  let productVariants = window.productData?.product.variants;
  let getVariant = productVariants.find((variant) => variant.id == id);
  let alertSizeEl = document.querySelector("#alertSize");
  let alertPriceEl = document.querySelector("#alertPrice");

  alertPriceEl.innerHTML = Currency.formatMoney(getVariant.price);
  if (!window.productData?.hasOnlyDefaultVariant) {
    alertSizeEl.innerHTML = getVariant.title;

    // check and control size visibility for alert
    popupSizeVisibilityControl(getVariant.title, alertSizeEl);
  }
}

/**
 * Control mobile ATC alert size visibility when option is UNI or -(hyphen)
 * @param {String} optionName - option name of the selected swatch
 * @param {Element} ele - child element of size wrapper
 */
function popupSizeVisibilityControl(optionName, ele) {
  let sizeWrapper = ele.parentElement;
  optionName = optionName?.toLowerCase();

  if (optionName == "uni" || optionName == "-") {
    sizeWrapper.classList.add("hide");
  } else {
    sizeWrapper.classList.remove("hide");
  }
}

/**
 * notify me form trigger mobile
 */
function notifyMeTrigger() {
  let alertContEl = document.querySelector("#notify_me_alert");
  if (window.matchMedia("(max-width:767px)").matches) {
    notifyMeEle.forEach((ele) => {
      ele.addEventListener("click", () => {
        alertContEl.classList.add("active");
      });
    });
  }
}
notifyMeTrigger();

function toggleDetails() {
  // Fetch all the details element.
  const details = document.querySelectorAll(".pdp-accordion-mob details");

  // Add the onclick listeners.
  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      // Close all the details that are not targetDetail.
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });
}
toggleDetails();

// sticky buttons click notify me display
let stickyVariantButtons = Array.from(
  document.querySelectorAll(".pdp-sticky-bar .pdp-swatch")
);
let stickyNotifyButtons = Array.from(
  document.querySelectorAll(".desktop-sticky-bar .pdp-notify")
);
let onlyStickyButton = Array.from(
  document.querySelectorAll(".pdp-sticky-bar .pdp-notify")
);
let notifyButtons = [
  ...stickyVariantButtons,
  ...stickyNotifyButtons,
  ...onlyStickyButton,
];
notifyButtons.forEach((el, ind) => {
  el.addEventListener("click", () => {
    let correspondingSwatch = document.querySelector(
      `product-info .pdp-swatch[data-value='${el.dataset.value}']`
    );
    correspondingSwatch?.classList.add("active");
    scrollToNotify();
  });
});
function scrollToNotify() {
  let pdpNotify = document.querySelector(".prod-info notify-form");
  pdpNotify.scrollIntoView({ behavior: "smooth", block: "end" });
}
